import { useSessionStorage } from "@allwyn/storage/composables/use-storage";
import { NgRestoreSession } from "@allwyn/utils/models/ng-fw";

const PENDING_RESTORE_KEY = "app-webview-session-restore";

const MAX_RESTORE_ATTEMPTS = 5;

interface PendingWebViewRestore {
    playerId: string;
    sessionToken: string;
    attempts: number;
}

const storage = useSessionStorage();

function readPendingWebViewRestore(): PendingWebViewRestore | null {
    const pending = storage.getJson<PendingWebViewRestore>(PENDING_RESTORE_KEY);
    return pending?.playerId && pending?.sessionToken ? pending : null;
}

export function getPendingWebViewRestore(): NgRestoreSession | null {
    const pending = readPendingWebViewRestore();
    return pending ? { playerId: pending.playerId, sessionToken: pending.sessionToken } : null;
}

export function persistPendingWebViewRestore({ playerId, sessionToken }: NgRestoreSession) {
    const pending = readPendingWebViewRestore();
    const isSameHandoff = pending?.playerId === playerId && pending?.sessionToken === sessionToken;

    storage.setJson<PendingWebViewRestore>(
        PENDING_RESTORE_KEY,
        { playerId, sessionToken, attempts: isSameHandoff ? pending.attempts : 0 },
        "essential"
    );
}

export function clearPendingWebViewRestore() {
    storage.removeItem(PENDING_RESTORE_KEY);
}

/**
 * @returns true when the attempt budget is exhausted and the handoff has been dropped
 */
export function registerFailedWebViewRestore(): boolean {
    const pending = readPendingWebViewRestore();
    const attempts = (pending?.attempts ?? 0) + 1;

    if (!pending || attempts >= MAX_RESTORE_ATTEMPTS) {
        clearPendingWebViewRestore();
        return true;
    }

    storage.setJson<PendingWebViewRestore>(PENDING_RESTORE_KEY, { ...pending, attempts }, "essential");
    return false;
}
